import { twMerge } from "tailwind-merge";

const useSwitchStyles = (checked: boolean, disabled?: boolean) => {
  const containerClassName = twMerge(
    "relative rounded-full",
    disabled
      ? "bg-fds-tertiary cursor-auto"
      : checked
        ? "bg-fds-brand hover:bg-fds-brand-hover cursor-pointer"
        : "bg-fds-tertiary-hover cursor-pointer"
  );

  const circleClassName = twMerge(
    "rounded-full absolute top-0.5 transition-[right]",
    disabled ? "bg-fds-secondary" : "bg-fds-primary"
  );

  const labelClassName = "text-fds-primary";

  return {
    containerClassName,
    circleClassName,
    labelClassName,
  };
};

export default useSwitchStyles;
